
export default {
  init() {
    // JavaScript to be fired on pages that use the alternating section layout
    $(document).ready(function() {
      $('.filter-group-buttons a').on('click', function(e) {
        console.log($(this).data('type'))
        e.preventDefault()
        $('.filter-group-buttons a').removeClass('active')
        $(this).addClass('active')

        $.ajax({
          type: 'POST',
          url: 'https://myriadstg.wpengine.com/wp-admin/admin-ajax.php',
          dataType: 'html',
          data: {
            action: 'filter_resources',
            category: $(this).data('type'),
          },
          success: function(res) {
            $('#daf-filter').html(res);
          },
          error: function(err) {
            console.log('error: '+err);
          },
        })
      })
    })
  },
  finalize() {
    // JavaScript to be fired on pages that use the alternating section layout, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/resourcesAjaxFilter.js